module.exports = __webpack_public_path__ + "static/media/bmassist1.1e27d4fb.pdf";